import { fetchApi } from "../../tools";

export const hooksService = async ( url, headers, objeto ) => {
    const data = await fetchApi({
        url: `${url}/utils/busquedas`,
        headers: headers,
        content: objeto,
      });
      return data || { msg: [] };
}